import { useEffect } from 'react';

const useServiceWorker = () => {
	useEffect(() => {
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker.register('/sw.js', { scope: '/' })
				.then(reg => console.log('Service Worker registered:', reg))
				.catch(err => console.error('Service Worker registration failed:', err));

			navigator.serviceWorker.addEventListener('controllerchange', () => {
				// Optional: reload page when new SW activates
				window.location.reload();
			});
		}
	}, []);

	return null; // no need to return SW registration
};

export default useServiceWorker;
